import React from 'react';
export class CodeBracketSquareOutline extends React.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            return (React.createElement(React.Fragment, null,
                React.createElement("svg", { className: this.props.className || 'w-5 h-5', viewBox: '0 0 24 24', stroke: 'currentColor', strokeWidth: '1.5', fill: 'none', style: this.props.style },
                    React.createElement("path", { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M14.25 9.75L16.5 12l-2.25 2.25m-4.5 0L7.5 12l2.25-2.25M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z' }))));
        };
    }
}
